import script from "./LoginFormView.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginFormView.vue?vue&type=script&setup=true&lang=ts"

import "./LoginFormView.vue?vue&type=style&index=0&id=0e495eb1&scoped=true&lang=less"

import exportComponent from "/Users/jeff/projects/js/pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e495eb1"]])

export default __exports__